import { ClockIcon } from "lucide-react";

import { Separator } from "@/components/ui/separator";

import { EmptyState } from "@/shared/components/EmptyState";

import { TicketHistoryEntry } from "../types/index";
import { TicketHistoryEntryRow } from "./TicketHistoryEntryRow";

interface TicketHistoryListProps {
  entries: TicketHistoryEntry[];
}

export function TicketHistoryList({ entries }: TicketHistoryListProps) {
  if (entries.length === 0) {
    return <EmptyState icon={ClockIcon} title="No history yet" description="Changes to this ticket will show up here." />;
  }

  return (
    <div className="flex flex-col">
      {entries.map((entry, i) => (
        <div key={entry.id}>
          <TicketHistoryEntryRow entry={entry} />
          {i < entries.length - 1 && <Separator />}
        </div>
      ))}
    </div>
  );
}
